module.exports = __webpack_public_path__ + "static/media/albania.774e3d22.svg";